<!-- ChipsSelector.vue -->
<template>
  <div class="chips-container" :class="'modo-' + modo">
    <span
      v-for="item in items"
      :key="item.valor"
      class="chip"
      :class="{ activo: seleccion.includes(item.valor) }"
      @click="toggle(item.valor)"
    >
      {{ item.etiqueta }}
    </span>
  </div>
</template>

<script>
const CONFIG = {
  mes: {
    campo: 'dias_mes',
    items: Array.from({ length: 31 }, (_, i) => ({
      valor: i + 1,
      etiqueta: String(i + 1).padStart(2, '0')
    }))
  },
  semana: {
    campo: 'dias_semana',
    items: [
      { valor: 1, etiqueta: 'Lu' },
      { valor: 2, etiqueta: 'Ma' },
      { valor: 3, etiqueta: 'Mi' },
      { valor: 4, etiqueta: 'Ju' },
      { valor: 5, etiqueta: 'Vi' },
      { valor: 6, etiqueta: 'Sa' },
      { valor: 7, etiqueta: 'Do' }
    ]
  },
  horas: {
    campo: 'horas_dia',
    items: Array.from({ length: 24 }, (_, i) => ({
      valor: i + 1,
      etiqueta: String(i + 1).padStart(2, '0')
    }))
  }
}

export default {
  name: 'ChipsSelector',
  props: {
    data: { type: Object, required: true },
    modo: {
      type: String,
      required: true,
      validator: v => ['mes', 'semana', 'horas'].includes(v)
    }
  },
  emits: ['toggle'],
  data() {
    return {
      seleccion: this.parseValores(this.data[CONFIG[this.modo].campo])
    }
  },
  computed: {
    campo() {
      return CONFIG[this.modo].campo
    },
    items() {
      return CONFIG[this.modo].items
    }
  },
  watch: {
    // Resincroniza si el padre actualiza el dato real
    'data': {
      deep: true,
      handler() {
        this.seleccion = this.parseValores(this.data[this.campo])
      }
    }
  },
  methods: {
    parseValores(str) {
      if (!str) return []
      return String(str)
        .split(',')
        .map(s => s.trim())
        .filter(s => s !== '')
        .map(Number)
    },
    arrayToString(arr) {
      return arr.length ? ',' + arr.join(',') : ''
    },
    toggle(valor) {
      const idx = this.seleccion.indexOf(valor)
      const seleccionado = idx === -1

      // Actualizaci�n optimista
      if (seleccionado) {
        this.seleccion.push(valor)
        this.seleccion.sort((a, b) => a - b)
      } else {
        this.seleccion.splice(idx, 1)
      }

      this.$emit('toggle', {
        modo: this.modo,
        valor,
        seleccionado,
        row: this.data,
        nuevoValor: this.arrayToString(this.seleccion)
      })
    }
  }
}
</script>

<style scoped>
.chips-container {
  display: grid;
  gap: 2px;
}
/* Mes: 7 columnas (calendario) */
.modo-mes {
  grid-template-columns: repeat(7, 1fr);
  max-width: 230px;
}
/* Horas: 6 columnas x 4 filas = 24 */
.modo-horas {
  grid-template-columns: repeat(6, 1fr);
  max-width: 200px;
}
/* Semana: en fila */
.modo-semana {
  display: flex;
  gap: 4px;
}

.chip {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  font-size: 0.72rem;
  border-radius: 3px;
  background: #ececec;
  color: #888;
  cursor: pointer;
  user-select: none;
  transition: background 0.15s, color 0.15s;
}
.chip:hover {
  opacity: 0.8;
}

/* Colores por modo */
.modo-mes .chip.activo {
  background: #29b6f6;
  color: #fff;
  font-weight: 600;
}
.modo-semana .chip.activo {
  background: #d81b60;
  color: #fff;
  font-weight: 600;
}
.modo-horas .chip.activo {
  background: #66bb6a;
  color: #fff;
  font-weight: 600;
}
</style>